import { Time } from '@angular/common';
import Model from 'src/app/common/model';
import FeedLogModel from './feedLog.model';

export default class FeedMealModel extends Model {
  given_time: Time;
  feedLog: FeedLogModel;
  feedTypes?: Array<IFeedTypes>;
  feed_log_id: number;
  meal_required: number;
  meal_given: number;
  last_meal: boolean;
  smart_meal: boolean;
  meal_consumed: number;
  pond_id?: number;
  pond_culture_id?: number;
  skip_reason?: string;
  createddate: string;
  createdAttime: string;

 constructor() {
    super();
    this.feedTypes = new Array();
  }
}

//////////////////////////////
//IFeedTypes
//////////////////////////////
export class IFeedTypes {
  feed_item_id?: number;
  feed_business_item_id?: number;
  feed_uom_id?: number;
  feed_qty_given?: number;
  mix_item_id?: number;
  mix_business_item_id?: number;
  mix_uom_id?: number;
  mix_qty_given?: number;

  constructor() {
  }
}
